var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorUpcoming = function SvgMultiColorUpcoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 4,
    y: 4,
    fill: "#130E3A",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.303 6.037H15.58v-.514h-.435v.514H12.07v-.514h-.433v.514H9.233v-.514H8.8v.514H6.696c-.31 0-.609.14-.829.387a1.4 1.4 0 0 0-.344.934v9.798c0 .35.124.686.344.933.22.248.518.387.83.387h10.606c.31 0 .61-.14.83-.387a1.4 1.4 0 0 0 .343-.933V7.358c0-.35-.124-.686-.344-.934a1.1 1.1 0 0 0-.83-.387m.74 11.119a.9.9 0 0 1-.217.588.7.7 0 0 1-.523.244H6.696a.7.7 0 0 1-.522-.244.9.9 0 0 1-.217-.588V8.944h12.086zm0-8.7H5.957V7.358c0-.22.079-.432.217-.588a.7.7 0 0 1 .522-.243H8.8v.514h.433v-.514h2.405v.514h.433v-.514h3.074v.514h.433v-.514h1.723c.196 0 .384.088.523.244a.9.9 0 0 1 .217.588z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.302 10.934-4.318 4.335a.186.186 0 0 1-.262 0l-2.039-2.046a.187.187 0 0 1 0-.264l.423-.424a.19.19 0 0 1 .202-.04q.034.014.06.04l1.354 1.359a.19.19 0 0 0 .202.04.2.2 0 0 0 .06-.04l3.633-3.648a.19.19 0 0 1 .202-.04q.034.014.06.04l.423.424a.187.187 0 0 1 0 .264"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC22F",
    d: "M9.368 5.523h-.74v1.711h.74z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F71278",
    d: "M12.36 5.523h-.739v1.711h.739z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACB29",
    d: "M15.743 5.523h-.74v1.711h.74z"
  })));
};
export { SvgMultiColorUpcoming as ReactComponent };